//Componentes generales
import React, { useReducer } from "react";
import controlGLBReducer from "./controlGLBReducer";
import controlGLBContext from "./controlGLBContext";
import moment from "moment";

//Axios
import clienteAxios from "../../config/axios";

import { Buffer } from "buffer";

//Rutas de api
import { getProductsByTDocNroFor } from "../../api/product";
import {
  createPDFReq,
  getFiles,
  updateTDoc,
  sentToWebService,
} from "../../api/transactionDocuments";

//Acciones
import {
  BUSCAR_TDOCS,
  MODIFICAR_FILTROS,
  CARGANDO_CONTROL,
  REINICIAR_FILTROS,
  CAMBIAR_FROM,
  SELECCIONAR_TDOC,
  ACTUALIZAR_TDOC,
  AGREGAR_TDOC,
  NOTIFICACION,
} from "./controlGLBActions";
import { getNewFormattedDate } from "../../utils/formatDate";

/* 
    State encargado de la gestión de filtros y listado de comprobantes.
*/
const ControlGLBState = (props) => {
  //Valores iniciales
  const initialState = {
    filtros: {
      state: [],
      fecAlt: {
        desde: new Date(moment(new Date()).subtract(15, "days")),
        hasta: new Date(moment(new Date())),
      },
      dateOfIssue: {
        desde: new Date(moment(new Date()).subtract(15, "days")),
        hasta: new Date(moment(new Date())),
      },
      userName: [],
    },
    tDocSelected: {},
    notificacion: "",
    from: "Control",
  };

  const [state, dispatch] = useReducer(controlGLBReducer, initialState);

  /* 
        Recupera los productos/items de un comprobante a partir de su nrofor.
            Donde tDocCodFor es el codfor del comprobante.
                  tDocNroFor es el nrofor del comprobante.
    */
  const getProductsByNroFor = async (tDocCodFor, tDocNroFor) => {
    try {
      const resp = await getProductsByTDocNroFor(tDocCodFor, tDocNroFor);

      return resp.data.data;
    } catch (error) {
      console.log(error.response);
    }
  };

  /* 
        Encargado de la modificación del estado de autorización.
    */
  const modificarComprobante = async (data, usuario, upd) => {
    try {
      const formData = new FormData();

      formData.append("tDocId", JSON.stringify(data._id));
      formData.append("user", JSON.stringify(usuario));
      formData.append("updates", JSON.stringify(upd));
      formData.append("fecMod", JSON.stringify(data.fecMod || getNewFormattedDate()));

      const resp = await updateTDoc(formData);
      dispatch({
        type: ACTUALIZAR_TDOC,
        payload: resp.data.data,
      });
      const tDocUpdated = resp.data;
      return tDocUpdated;
    } catch (error) {
      console.log(error);
      /* dispatch({
        type: NOTIFICACION,
        payload: error.response.data.errMsg,
      }); */
      throw error;
    }
  };

  /* 
        Función encargada de hacer la solicitud al web service de enviar los datos indicados por parametros.
            Donde data es el comprobante a enviar.
                  usuario es el usuario en sesión.
    */
  const enviarReqApi = async (data, usuario) => {
    try {
      //await sentToWebService(data._id, usuario);
      const resp = await sentToWebService(data._id, usuario);
      return resp;
    } catch (error) {
      console.log(error.response.data);
      const mensaje =
        error.response.data.message !== ""
          ? error.response.data.message
          : error.message;
      throw new Error(mensaje);
    }
  };

  const setFrom = (value) => {
    dispatch({
      type: CAMBIAR_FROM,
      payload: value,
    });
  };

  /* 
        Función encargada de abrir en base 64 un String. Utilizada para ver el informe de comprobante en pdf.
    */
  function openBase64PDF(base64String) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });

    const fileUrl = URL.createObjectURL(blob);
    window.open(fileUrl);
  }

  /* 
        Función encargada de generar un pdf del comprobante.
            Donde tDoc es el comprobante.
                  usuario es el usuario en sesión.
    */
  const generarInformeReqPDF = async (tDoc, usuario) => {
    try {
      const resp = await createPDFReq(
        tDoc.tDocCodFor,
        tDoc.tDocNroFor,
        usuario._id
      ); //clienteAxios.post('/transactionDocument/informe', { tDocCodFor: tDoc.tDocCodFor, tDocNroFor: tDoc.tDocNroFor, userId: usuario._id });

      const buff = Buffer.from(resp.data, "base64");
      const base64 = buff.toString("base64");

      openBase64PDF(base64);
    } catch (error) {
      console.log(error);
      console.log("Error en generar informe comprobante PDF");
    }
  };

  /* 
        Función encargada de recuperar los archivos adjuntados a un comprobante especifico.
            Donde tDoc es el comprobante.
    */
  const getFilesByTDoc = async (tDoc) => {
    try {
      const resp = await getFiles(tDoc.tDocCodFor, tDoc.tDocNroFor);

      return resp.data.data;
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  return (
    <controlGLBContext.Provider
      value={{
        filtros: state.filtros,
        tDocSelected: state.tDocSelected,
        notificacion: state.notificacion,
        from: state.from,
        getProductsByNroFor,
        modificarComprobante,
        setFrom,
        generarInformeReqPDF,
        getFilesByTDoc,
        enviarReqApi,
      }}
    >
      {props.children}
    </controlGLBContext.Provider>
  );
};

export default ControlGLBState;
